import Plantilla from '@/components/AdministradorConvocatorias/comun/Plantilla.vue'
import AltaDeConvocatoria from '@/components/AdministradorConvocatorias/AltaConvocatoria/AltaConvocatoria.vue'
import ConsultaConvocatoria from '@/components/AdministradorConvocatorias/ConsultaConvocatorias/ConsultaConvocatoria.vue'

                                                                                                                                                           
//Se crea la lista de los paths
const CONVOCATORIAS = [
  { 
    name: 'CONVOCATORIA', 
    path: '/CONVOCA', 
    component: Plantilla, 
    meta: { tituloDeLaPagina: "Sistema de Control de Convocatorias", 
    RequiereAutenticacion: true, 
    ValidaSesion: true, 
    ObtenDatos: true, 
    ObtenPermisosDelSistema: true, 
    SistemaQueSeIngreso: 43 }, 
    children: [
      { 
        name: 'CrearConvocatoria', 
        path: 'AltaConvocatoria', 
        component: AltaDeConvocatoria, 
        meta: { 
          tituloDeLaPagina: "Alta de convocatoria", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 43,
          ModuloId: 1 
        } 
      },
      { 
        name: 'ConsultaConvocatoria', 
        path: 'ConsultaConvocatoria', 
        component: ConsultaConvocatoria, 
        meta: { 
          tituloDeLaPagina: "Consulta de Convocatorias", 
          RequiereAutenticacion: true, 
          ValidaSesion: true, 
          ObtenDatos: true, 
          ObtenPermisosDelSistema: true, 
          SistemaQueSeIngreso: 43,
          ModuloId: 1,
          FuncionId: 2 
        } 
      },
      // { 
      //   name: 'AdministracionDeSubmenusPaginaWeb', 
      //   path: 'AdministracionDeSubmenusPaginaWeb', 
      //   component: CAdministracionDeSubmenus, 
      //   meta: { 
      //     tituloDeLaPagina: "Administración de submenús página web", 
      //     RequiereAutenticacion: true, 
      //     ValidaSesion: true, 
      //     ObtenDatos: true, 
      //     ObtenPermisosDelSistema: true, 
      //     SistemaQueSeIngreso: 23,
      //     ModuloId: 2,
      //     FuncionId: 7 
      //   } 
      // },
      // { 
      //   name: 'AdministracionDeMenusPaginaWeb', 
      //   path: 'AdministracionDeMenusPaginaWeb', 
      //   component: CAdministracionDeMenus, 
      //   meta: { 
      //     tituloDeLaPagina: "Administración de menús página web", 
      //     RequiereAutenticacion: true, 
      //     ValidaSesion: true, 
      //     ObtenDatos: true, 
      //     ObtenPermisosDelSistema: true, 
      //     SistemaQueSeIngreso: 23,
      //     ModuloId: 2,
      //     FuncionId: 9 
      //   } 
      // },
      // { 
      //   name: 'AdministracionDePermisosPaginaWeb', 
      //   path: 'Permisos', 
      //   component: CPermisosPaginaWeb, 
      //   meta: { 
      //     tituloDeLaPagina: "Administracion De Permisos Pagina Web", 
      //     RequiereAutenticacion: true, 
      //     ValidaSesion: true, 
      //     ObtenDatos: true, 
      //     ObtenPermisosDelSistema: true, 
      //     SistemaQueSeIngreso: 23,
      //     ModuloId: 2,
      //     FuncionId:16 
      //   } 
      // },
      // { 
      //   name: 'AdministracionAsistentes', 
      //   path: 'AdministracionAsistentesConvocatoriasWeb', 
      //   component: AdministracionAsistentes, 
      //   meta: { 
      //     tituloDeLaPagina: "Administracion De Asistentes", 
      //     RequiereAutenticacion: false, 
      //     ValidaSesion: false, 
      //     ObtenDatos: true, 
      //     ObtenPermisosDelSistema: true, 
      //     SistemaQueSeIngreso: 23,
      //     ModuloId: 2,
      //     FuncionId:18 
      //   } 
      // },
      // { 
      //   name: 'CrearContenidoMicrositio', 
      //   path: 'AltaDeContenidoMicrositio', 
      //   component: AltaDeContenidoMicrositio, 
      //   meta: { 
      //     tituloDeLaPagina: "Sistema de Control Micrositios", 
      //     RequiereAutenticacion: true, 
      //     ValidaSesion: true, 
      //     ObtenDatos: true, 
      //     ObtenPermisosDelSistema: true, 
      //     SistemaQueSeIngreso: 23,
      //     ModuloId: 2 
      //   } 
      // },
      // { 
      //   name: 'EditarContenidoMicrositio', 
      //   path: 'EdicionDeContenidoMicrositio', 
      //   component: EdicionDeContenidoMicrositio, 
      //   meta: { 
      //     tituloDeLaPagina: "Sistema de Control Micrositios", 
      //     RequiereAutenticacion: true, 
      //     ValidaSesion: true, 
      //     ObtenDatos: true, 
      //     ObtenPermisosDelSistema: true, 
      //     SistemaQueSeIngreso: 23,
      //     ModuloId: 2 
      //   } 
      // },
      // { 
      //   name: 'AdministradorDeMenuMicrositio', 
      //   path: 'AdministradorDeMenusMicrositios', 
      //   component: AdministradorDeMenuMicrositio, 
      //   meta: { 
      //     tituloDeLaPagina: "Administración de menús Micrositios", 
      //     RequiereAutenticacion: true, 
      //     ValidaSesion: true, 
      //     ObtenDatos: true, 
      //     ObtenPermisosDelSistema: true, 
      //     SistemaQueSeIngreso: 23,
      //     ModuloId: 2 
      //   } 
      // },
      // { 
      //   name: 'AdministradorDeSubmenusMicrositio', 
      //   path: 'AdministradorDeSubmenusMicrositios', 
      //   component: AdministradorDeSubmenuMicrositio, 
      //   meta: { 
      //     tituloDeLaPagina: "Administración de submenús Micrositios", 
      //     RequiereAutenticacion: true, 
      //     ValidaSesion: true, 
      //     ObtenDatos: true, 
      //     ObtenPermisosDelSistema: true, 
      //     SistemaQueSeIngreso: 23,
      //     ModuloId: 2 
      //   } 
      // },
      // { 
      //   name: 'BusquedaDeDocumentosContenidos', 
      //   path: 'BusquedaDeDocumentosContenidos', 
      //   component: CDocumentosDeContenidos, 
      //   meta: { 
      //     tituloDeLaPagina: "Búsqueda de documentos página web", 
      //     RequiereAutenticacion: true, 
      //     ValidaSesion: true, 
      //     ObtenDatos: true, 
      //     ObtenPermisosDelSistema: true, 
      //     SistemaQueSeIngreso: 23,
      //     ModuloId: 2,
      //     FuncionId: 11 
      //   } 
      // },
      // { 
      //   name: 'AdministracionDeContenidosIntranet', 
      //   path: 'AdministracionDeContenidosIntranet', 
      //   component: CAdministracionDeContenidos, 
      //   meta: { 
      //     tituloDeLaPagina: "Administración de contenidos intranet", 
      //     RequiereAutenticacion: true, 
      //     ValidaSesion: true, 
      //     ObtenDatos: true, 
      //     ObtenPermisosDelSistema: true, 
      //     SistemaQueSeIngreso: 23,
      //     ModuloId: 1,
      //     FuncionId: 13 
      //   } 
      // },
      // { 
      //   name: 'AdministracionDePermisosIntranet', 
      //   path: 'AdministracionDePermisosIntranet', 
      //   component: CPermisosIntranet, 
      //   meta: { 
      //     tituloDeLaPagina: "Administración de permisos intranet", 
      //     RequiereAutenticacion: true, 
      //     ValidaSesion: true, 
      //     ObtenDatos: true, 
      //     ObtenPermisosDelSistema: true, 
      //     SistemaQueSeIngreso: 23,
      //     ModuloId: 1,
      //     FuncionId: 14 
      //   } 
      // },
      // { 
      //   name: 'AdministradorDeDocumentos', 
      //   path: '/AdministracionDePermisosIntranet', 
      //   component: AdministradorDeDocumentos, 
      //   meta: { 
      //     tituloDeLaPagina: "Busqueda De Archivos Micrositios", 
      //     RequiereAutenticacion: true, 
      //     ValidaSesion: true, 
      //     ObtenDatos: true, 
      //     ObtenPermisosDelSistema: true, 
      //     SistemaQueSeIngreso: 23,
      //     ModuloId: 2, 
      //   } 
      // },
      // { 
      //   name: 'AdministracionComunicadosMicrositios', 
      //   path: 'AdministracionComunicadosMicrositios', 
      //   component: AdministradorDeComunicados, 
      //   meta: { 
      //     tituloDeLaPagina: "Administracion De Comunicados Micrositios", 
      //     RequiereAutenticacion: true, 
      //     ValidaSesion: true, 
      //     ObtenDatos: true, 
      //     ObtenPermisosDelSistema: true, 
      //     SistemaQueSeIngreso: 23,
      //     ModuloId: 3,
      //     FuncionId:15 
      //   } 
      // },

      // { 
      //   name: 'PermisosMicrositios', 
      //   path: 'PermisosMicrositios', 
      //   component: PermisosMicrositios, 
      //   meta: { 
      //     tituloDeLaPagina: "Administración De Permisos Micrositios", 
      //     RequiereAutenticacion: true, 
      //     ValidaSesion: true, 
      //     ObtenDatos: true, 
      //     ObtenPermisosDelSistema: true, 
      //     SistemaQueSeIngreso: 23,
      //     ModuloId: 3,
      //     FuncionId:17 
      //   } 
      // },
    ] 
  }
]

//Se regresa la lista de los paths
export default CONVOCATORIAS;



// WEBPACK FOOTER //
// ./src/router/ConvocatoriasAdministrador.js